import svg4everybody from 'svg4everybody'

export default () => {
  svg4everybody()
}
